import PropTypes from "prop-types";
import BaseComponent from "../../../../lib/components/BaseComponent";
import Operator from "../../../../lib/model/query/Operator";
import {ToggleButton, ToggleButtonGroup} from "@mui/material";
import T from "../../../model/system/text_translations/Translator";

class BooleanPredicate extends BaseComponent {

  constructor(props) {
    super(props);
    this._type = 'BooleanPredicateComponent';
    this.state = {
      operator: (this.props.operator || Operator.and)
    };
  }

  onOperatorChanged(event, newOperator) {
    this.setState({operator: newOperator});
  }

  getOperator() {
    return this.state.operator;
  }

  render() {
    return <ToggleButtonGroup color='primary' sx={{height: 30}} value={this.state.operator} className='mb-2'>
      <ToggleButton value={Operator.and} size='small'
                    onClick={(e) => this.onOperatorChanged(e, Operator.and)}>
        {T.ext_filter_and_label()}
      </ToggleButton>
      <ToggleButton value={Operator.or} size='small'
                    onClick={(e) => this.onOperatorChanged(e, Operator.or)}>
        {T.ext_filter_or_label()}
      </ToggleButton>
    </ToggleButtonGroup>
  }
}

BooleanPredicate.propTypes = {
  className: PropTypes.string, operator: PropTypes.string
}
export default BooleanPredicate;
